var map = {
	"./avatar-appcivico.jpg": 395,
	"./avatar-recipient.jpg": 166,
	"./facebook-logo-button-white.png": 396,
	"./facebook-logo-button.png": 397,
	"./loading-white.svg": 398,
	"./logo-m-a-branco-54dd555a.svg": 399,
	"./user.jpg": 400,
	"./user1-128x128.jpg": 401,
	"./user4-128x128.jpg": 402
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;


//////////////////
// WEBPACK FOOTER
// ./_source/images nonrecursive \.(png|jpg|gif|svg)$
// module id = 394
// module chunks = 0